// src/utils/ga.js

/**
 * Google Analytics로 이벤트를 전송하는 함수 (GA4 데이터 모델에 최적화)
 * @param {string} eventName - 이벤트 이름 (예: 'click_translate')
 * @param {object} [eventParams={}] - 이벤트와 함께 전송할 매개변수 객체
 */
export const trackEvent = (eventName, eventParams = {}) => {
    // window.gtag 함수가 사용 가능한지 확인 (GA 스크립트가 로드되었는지)
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, eventParams);
        console.log(`GA Event Sent: ${eventName}`, eventParams); // 개발 중 확인을 위한 로그
    } else {
        console.warn("GA gtag.js not loaded. Event not tracked.");
    }
};
